import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueToast from 'vue-toast-notification';
import VueCookies from 'vue-cookies'
import vueautowidth from 'vue-input-autowidth';
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
/* eslint-disable */
Vue.component('apexchart', VueApexCharts)
Vue.config.productionTip = false
Vue.use(VueToast);
Vue.use(vueautowidth);
Vue.use(VueCookies, { expire: '7d'})
new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
